import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',

    '& span': {
      fontSize: theme.size.base,
      color: '#1F1F1F'
    },

    '& .close': {
      cursor: 'pointer'
    }
  },

  avatars: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: ({ avatarsOverflowing }) =>
      avatarsOverflowing ? '16px' : '0',
    paddingBottom: '16px',
    overflowX: 'auto',

    '& > :not(:last-child)': {
      marginRight: '8px'
    },

    '&::-webkit-scrollbar': {
      borderRadius: '4px',
      height: '8px'
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#8F8F8F'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B64FCD',
      borderRadius: '4px'
    }
  },

  avatar: {
    width: '48px',
    height: '48px'
  },

  rows: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '8px'
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    fontSize: theme.size.sm,
    color: '#1F1F1F',

    '&:last-child': {
      marginBottom: '0'
    },

    '& .icon': {
      marginRight: '8px',
      color: '#8F8F8F'
    },

    '& .label': {
      marginRight: '16px',
      minWidth: '50px',
      width: '50px',
      maxWidth: '50px',
      color: '#8F8F8F'
    },

    '& .value': {
      maxWidth: '170px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    '& .flag': {
      marginRight: '8px'
    },

    '& .compliance': {
      marginLeft: '8px',
      minWidth: '16px',
      color: '#FF3B3B'
    }
  },

  bottom: {
    display: 'grid',
    placeItems: 'center',
    backgroundColor: '#f5f6f8',
    padding: '8px'
  },

  profile: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '& > span': {
      margin: '0 8px',
      fontSize: theme.size.base,
      color: '#1F1F1F'
    }
  }
}))

export default useStyles
